export const buildSignupDecorationOrUndefined = (data) => {
    if (!data)
        return undefined;
    return {
        page: data.page || '',
        stage: data.stage || 'never-logged-in',
        planId: data.planId || 'FREE_2016',
        dateAdded: data.dateAdded || 0,
        numAttempts: data.numAttempts || 0,
    };
};
export const signupDecorationNewSignup = ({ planId, pathname, numAttempts, }) => {
    const attempts = numAttempts ? numAttempts + 1 : 1;
    return {
        planId,
        stage: 'never-logged-in',
        page: pathname,
        dateAdded: Date.now(),
        numAttempts: attempts,
    };
};
